export enum PricingPlanEnum {
  TRIAL = 'TRIAL',
  LITE = 'LITE',
  PRO = 'PRO',
}
